import React, { useContext } from 'react';

import { Context } from '../../../index';

const Exit = ({ color = '#A6B0CF' }) => {
  const { auth } = useContext(Context);
  const logout = () => {
    auth.signOut();
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      style={{ position: 'absolute', bottom: '20px', left: '25%', cursor: 'pointer' }}
      onClick={() => logout()}
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24 29.3335L12 29.3335C11.2928 29.3335 10.6145 29.0525 10.1144 28.5524C9.61431 28.0524 9.33335 27.3741 9.33335 26.6668L9.33335 25.3335C9.33335 24.9799 9.47383 24.6407 9.72388 24.3907C9.97393 24.1406 10.3131 24.0002 10.6667 24.0002C11.0203 24.0002 11.3594 24.1406 11.6095 24.3907C11.8595 24.6407 12 24.9799 12 25.3335L12 26.6668L24 26.6668L24 5.3335L12 5.3335L12 6.66683C12 7.02045 11.8595 7.35959 11.6095 7.60964C11.3594 7.85969 11.0203 8.00016 10.6667 8.00016C10.3131 8.00016 9.97392 7.85969 9.72388 7.60964C9.47383 7.35959 9.33335 7.02045 9.33335 6.66683L9.33335 5.3335C9.33335 4.62625 9.61431 3.94798 10.1144 3.44788C10.6145 2.94778 11.2928 2.66683 12 2.66683L24 2.66683C24.7073 2.66683 25.3855 2.94778 25.8856 3.44788C26.3857 3.94798 26.6667 4.62625 26.6667 5.3335L26.6667 26.6668C26.6667 27.3741 26.3857 28.0524 25.8856 28.5524C25.3855 29.0525 24.7073 29.3335 24 29.3335Z"
          fill={color}
        />
        <path
          d="M9.60667 10.2732C9.08667 9.75317 8.24666 9.75317 7.72667 10.2732L2.94267 15.0572C2.6927 15.3072 2.55228 15.6463 2.55228 15.9998C2.55228 16.3534 2.6927 16.6925 2.94267 16.9425L7.72667 21.7265C7.98012 21.9556 8.3119 22.0785 8.65342 22.0699C8.99495 22.0613 9.32011 21.9218 9.56168 21.6802C9.80325 21.4386 9.94277 21.1135 9.95139 20.7719C9.96001 20.4304 9.83707 20.0986 9.608 19.8452L7.10667 17.3332L18.6667 17.3332C19.0203 17.3332 19.3594 17.1927 19.6095 16.9426C19.8595 16.6926 20 16.3535 20 15.9998C20 15.6462 19.8595 15.3071 19.6095 15.057C19.3594 14.807 19.0203 14.6665 18.6667 14.6665L7.10667 14.6665L9.608 12.1545C9.85689 11.9046 9.99652 11.5662 9.99627 11.2136C9.99602 10.8609 9.85591 10.5227 9.60667 10.2732Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default Exit;
